const projects = [

{
project_id:"pp1",
name:"Paley MHP",
location:"Tali, Arunachal Pradesh",
capacity:"500KW",
capacity_value:500,
scope:["Complete Turnkey Project"],
description:"Complete Turnkey Hydro Project execution.",
latitude:28.0125449,
longitude:93.7312381,
image_url:"/images/projects/dhpd.png",
year:2025,
status:"ongoing",
turbine_type:"kaplan",
priority:1
},
{
project_id:"pp2",
name:"World's First Micro Hydro Mini Grid",
location:"Baglung, Nepal",
capacity:"",
capacity_value:500,
scope:["Complete Turnkey Project"],
description:"Design, Supply and installation of Mini Grid Pilot Project funded by World Bank and UNDP.",
latitude:28.2774,
longitude:83.5816,
image_url:"/images/projects/undp.png",
year:2012,
status:"ongoing",
turbine_type:"kaplan",
priority:2
},
{
project_id:"pp2",
name:"Gulmi Micro Hydro Mini Grid",
location:"Baglung, Nepal",
capacity:"",
capacity_value:500,
scope:["Complete Turnkey Project"],
description:"Design, Supply and installation of Mini Grid Pilot Project funded by World Bank and UNDP.",
latitude:28.09643,
longitude:83.33414,
image_url:"/images/projects/undp.png",
year:2012,
status:"ongoing",
turbine_type:"kaplan",
priority:7
},
{
project_id:"pp3",
name:"Katar Nallah - I MHP",
location:"Limeking, Arunachal Pradesh",
capacity:"100KW",
capacity_value:100,
scope:["Complete Turnkey Project"],
description:"Complete Turnkey Hydro Project execution.",
latitude:28.25881,
longitude:93.59498,
image_url:"/images/projects/dhpd.png",
year:2022,
status:"completed",
turbine_type:"francis",
priority:6
},

{
project_id:"pp9",
name:"Kotijhala SHP",
location:"Tehri, Uttarakhand",
capacity:"2*150KW",
capacity_value:300,
scope:["Complete Turnkey Project"],
description:"Complete Turnkey Hydro Project execution.",
latitude:30.354426,
longitude:78.44866,
image_url:"/images/projects/ureda.png",
year:2022,
status:"ongoing",
turbine_type:"francis"
},

{
project_id:"pp8",
name:"Katar Nallah - II MHP",
location:"Limeking, Arunachal Pradesh",
capacity:"100KW",
capacity_value:100,
scope:["Complete Turnkey Project"],
description:"Complete Turnkey Hydro Project execution.",
latitude:28.36774,
longitude:93.59648,
image_url:"/images/projects/dhpd.png",
year:2025,
status:"ongoing",
turbine_type:"francis",
priority:6
},
/* ===== 36 ===== */
{
project_id:"pp0",
name:"Dooranallah SHP",
location:"Tezu, Arunachal Pradesh",
capacity:"3X100KW",
capacity_value:300,
scope:["Control Panel System"],
description:"Supply, Installation, testing and commissioning of complete control equipment of MHP.",
latitude:27.92967,
longitude:96.15326,
image_url:"/images/projects/toshiba.png",
year:2012,
status:"completed",
turbine_type:"unknown",
priority:3
},
/* ===== 43 ===== */
{
project_id:"p43",
name:"Relagad SHP Repair Project",
location:"Dharchula, Uttarakhand",
capacity:"2X1.5MW",
capacity_value:3000,
scope:["Governor Repair","OPU Unit","Control Wiring"],
description:"Repair of electronic Governor, OPU Unit and control wiring.",
latitude:29.8475,
longitude:80.5364,
image_url:"/images/projects/ujvnl.png",
year:2011,
status:"completed",
turbine_type:"pelton",
priority:4
},

{
project_id:"pp4",
name:"Ngo Siko MHP",
location:"Reddy, Arunachal Pradesh",
capacity:"2 X 50KW",
capacity_value:100,
scope:["Complete Turnkey Project"],
description:"Complete Turnkey Hydro Project execution.",
latitude:28.37728,
longitude:93.30756,
image_url:"/images/projects/dhpd.png",
year:2025,
status:"ongoing",
turbine_type:"francis"
},
{
project_id:"pp6",
name:"Sirikorong MHP",
location:"Mechuka, Arunachal Pradesh",
capacity:"300KW",
capacity_value:300,
scope:["Complete Turnkey Project"],
description:"Complete Turnkey Hydro Project execution.",
latitude:28.69436,
longitude:94.15369,
image_url:"/images/projects/dhpd.png",
year:2021,
status:"completed",
turbine_type:"francis"
},

{
project_id:"pp5",
name:"Korakunda MHP",
location:"Coimbatore, Tamil Nadu",
capacity:"60KW",
capacity_value:60,
scope:["Turbine System","Control Panels","Electronic Load Controller"],
description:"Project to power factory in Korakunda Tea Estate.",
latitude:11.22849,
longitude:76.58128,
image_url:"/images/projects/amalgamation.png",
year:2021,
status:"completed",
turbine_type:"crossflow",
priority:2
},
/* ===== 1 ===== */

{
project_id:"p1",
name:"Haflagad MHP",
location:"Pokhri, Uttarakhand",
capacity:"200KW",
capacity_value:200,
scope:["Electronic Governing System","Turbine","Control Panel"],
description:"Design, Supply and installation of Electronic Governing System and Turbine and control panel.",
latitude:30.11849,
longitude:78.69749,
image_url:"/images/projects/ureda.png",
year:2019,
status:"completed",
turbine_type:"crossflow"
},

/* ===== 2 ===== */
{
project_id:"p2",
name:"Tuiching MHP",
location:"Aizawl, Mizoram",
capacity:"100KW",
capacity_value:100,
scope:["Electronic Governing System","Turbine","Control Panel"],
description:"Design, Supply and installation of Electronic Governing System and Turbine and control panel.",
latitude:23.73054,
longitude:92.71862,
image_url:"/images/projects/mizoram.png",
year:2016,
status:"completed",
turbine_type:"unknown"
},

/* ===== 3 ===== */
{
project_id:"p3",
name:"Turiza MHP",
location:"Aizawl, Mizoram",
capacity:"100KW",
capacity_value:100,
scope:["Electronic Governing System","Turbine","Control Panel"],
description:"Design, Supply and installation of Electronic Governing System and Turbine and control panel.",
latitude:23.7271,
longitude:92.7176,
image_url:"/images/projects/dhpd.png",
year:2016,
status:"completed",
turbine_type:"unknown"
},

/* ===== 4 ===== */
{
project_id:"p4",
name:"Passighat MHP",
location:"Pasighat, Arunachal Pradesh",
capacity:"200KW",
capacity_value:200,
scope:["Electronic Governing System","Francis Turbine"],
description:"Design, Supply and installation of Electronic Governing System and Francis Turbine.",
latitude:28.0633,
longitude:95.32630,
image_url:"/images/projects/dhpd.png",
year:2016,
status:"completed",
turbine_type:"francis"
},

/* ===== 5 ===== */
{
project_id:"p5",
name:"Matinallah MHP",
location:"Anjaw District, Arunachal Pradesh",
capacity:"250KW",
capacity_value:250,
scope:["Electronic Governing System","Turbine","Control Panel"],
description:"Design, Supply and installation of Electronic Governing System and Turbine and control panel.",
latitude:27.9073,
longitude:96.8393,
image_url:"/images/projects/dhpd.png",
year:2018,
status:"completed",
turbine_type:"unknown"
},

/* ===== 6 ===== */
{
project_id:"p6",
name:"Kitpi SHP",
location:"Tawang, Arunachal Pradesh",
capacity:"2X1.5MW",
capacity_value:3000,
scope:["Electronic Governing","Excitation Control Panels"],
description:"Design, Supply and installation of Electronic Governing and Excitation Control Panels.",
latitude:27.58894,
longitude:91.87386,
image_url:"/images/projects/dhpd.png",
year:2016,
status:"completed",
turbine_type:"pelton"
},

/* ===== 7 ===== */
{
project_id:"p7",
name:"Nuranang SHP",
location:"Tawang, Arunachal Pradesh",
capacity:"3X2MW",
capacity_value:6000,
scope:["Electronic Governing System"],
description:"Design, Supply and installation of Electronic Governing System for Pelton Turbine.",
latitude:27.59059,
longitude:91.98331,
image_url:"/images/projects/ureda.png",
year:2016,
status:"completed",
turbine_type:"pelton"
},

/* ===== 8 ===== */
{
project_id:"p8",
name:"Noroi MHP",
location:"Nagaland",
capacity:"150KW",
capacity_value:150,
scope:["Hydro Project"],
description:"Hydro project supply and commissioning.",
latitude:25.6701,
longitude:94.1077,
image_url:"/images/projects/dnre.png",
year:2016,
status:"completed",
turbine_type:"unknown"
},

/* ===== 9 ===== */
{
project_id:"p9",
name:"Kedarnath MHP",
location:"Rudraprayag, Uttarakhand",
capacity:"200KW",
capacity_value:200,
scope:["Complete Hydro Project","Double Jet Pelton"],
description:"Supply, Installation and testing of Complete Hydro Project on turnkey base.",
latitude:30.73469,
longitude:79.06690,
image_url:"/images/projects/ureda.png",
year:2016,
status:"completed",
turbine_type:"pelton"
},

/* ===== 10 ===== */
{
project_id:"p10",
name:"Gangotri MHP",
location:"Uttarkashi, Uttarakhand",
capacity:"100KW",
capacity_value:100,
scope:["Hydro Turbine","MIV"],
description:"Supply, Installation and testing of Complete Hydro turbine with MIV.",
latitude:30.99434,
longitude:78.946306,
image_url:"/images/projects/ureda.png",
year:2015,
status:"completed",
turbine_type:"crossflow"
},
/* ===== 11 ===== */
{
project_id:"p11",
name:"Aalo Hydro Development Project",
location:"Aalo, Arunachal Pradesh",
capacity:"2X1000KW",
capacity_value:2000,
scope:["Electronic Governing System","Francis Turbine"],
description:"Design, Supply and installation of Electronic Governing System for Francis Turbine.",
latitude:28.16265,
longitude:94.80633,
image_url:"/images/projects/ureda.png",
year:2015,
status:"completed",
turbine_type:"francis"
},

/* ===== 12 ===== */
{
project_id:"p12",
name:"33KV Switchyard Project",
location:"Aalo, Arunachal Pradesh",
capacity:"33KV Switchyard",
capacity_value:0,
scope:["33KV Substation","Electrical Infrastructure"],
description:"Design, Supply and installation of 33KV Sub Station.",
latitude:28.1736,
longitude:94.7996,
image_url:"/images/projects/ureda.png",
year:2015,
status:"completed",
turbine_type:"na"
},

/* ===== 13 ===== */
{
project_id:"p13",
name:"Anjaw Axial Flow Project",
location:"Anjaw District, Arunachal Pradesh",
capacity:"50KW",
capacity_value:50,
scope:["Axial Flow Semi Kaplan Turbine","Complete E&M Equipment"],
description:"Design, Supply and installation of Axial Flow Semi Kaplan Turbine with complete E&M equipment.",
latitude:27.9073,
longitude:96.8393,
image_url:"/images/projects/ureda.png",
year:2015,
status:"completed",
turbine_type:"kaplan"
},

/* ===== 14 ===== */
{
project_id:"p14",
name:"Anjaw Double Jet Pelton Project",
location:"Anjaw District, Arunachal Pradesh",
capacity:"250KW",
capacity_value:250,
scope:["Double Jet Pelton Turbine","Electronic Governing System"],
description:"Design, Supply and installation of Double Jet Pelton Turbine and Electronic Governing System.",
latitude:28.01693,
longitude:96.96561,
image_url:"/images/projects/ureda.png",
year:2015,
status:"completed",
turbine_type:"pelton"
},

/* ===== 15 ===== */
{
project_id:"p15",
name:"Gondhar MHP",
location:"Rudraprayag, Uttarakhand",
capacity:"100KW",
capacity_value:100,
scope:["Complete Control Panels","Commissioning"],
description:"Supply, Installation testing and commissioning of complete Plant and Equipment of MHP.",
latitude:30.2844,
longitude:78.9818,
image_url:"/images/projects/ureda.png",
year:2015,
status:"completed",
turbine_type:"unknown"
},

/* ===== 16 ===== */
{
project_id:"p16",
name:"Teri MHP",
location:"Tehri Garhwal, Uttarakhand",
capacity:"2X100KW",
capacity_value:200,
scope:["Complete Plant Equipment","Commissioning"],
description:"Supply, Installation testing and commissioning of complete Plant and Equipment of MHP.",
latitude:30.3782,
longitude:78.4800,
image_url:"/images/projects/ureda.png",
year:2015,
status:"completed",
turbine_type:"unknown"
},

/* ===== 17 ===== */
{
project_id:"p17",
name:"Narming Tea Garden Project",
location:"Darjeeling, West Bengal",
capacity:"100KW",
capacity_value:100,
scope:["Double Jet Pelton Turbine"],
description:"Design, Supply and Installation of Double Jet Pelton Turbine.",
latitude:27.0360,
longitude:88.2627,
image_url:"/images/projects/ureda.png",
year:2015,
status:"completed",
turbine_type:"pelton"
},

/* ===== 18 ===== */
{
project_id:"p18",
name:"Liromuba Hydro Project",
location:"Arunachal Pradesh",
capacity:"2X1000KW",
capacity_value:2000,
scope:["Electronic Governor Panel"],
description:"Supply and installation of Electronic Governor Panel.",
latitude:27.0844,
longitude:93.6053,
image_url:"/images/projects/ureda.png",
year:2015,
status:"completed",
turbine_type:"unknown"
},

/* ===== 19 ===== */
{
project_id:"p19",
name:"Nienu MHP",
location:"Nagaland",
capacity:"100KW",
capacity_value:100,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:25.6701,
longitude:94.1077,
image_url:"/images/projects/ureda.png",
year:2014,
status:"completed",
turbine_type:"unknown"
},

/* ===== 20 ===== */
{
project_id:"p20",
name:"Yingkiyong MHP",
location:"Upper Siang, Arunachal Pradesh",
capacity:"150KW",
capacity_value:150,
scope:["ELC Control Panels"],
description:"Supply, installation, testing and commissioning of ELC Control Panels.",
latitude:28.6079,
longitude:95.0479,
image_url:"/images/projects/ureda.png",
year:2014,
status:"completed",
turbine_type:"unknown"
},

/* ===== 21 ===== */
{
project_id:"p21",
name:"Dali MHP",
location:"Basar, Arunachal Pradesh",
capacity:"400KW",
capacity_value:400,
scope:["Complete Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.98247,
longitude:94.68850,
image_url:"/images/projects/dhpd.png",
year:2014,
status:"completed",
turbine_type:"unknown"
},

/* ===== 22 ===== */
{
project_id:"p22",
name:"Pagi MHP",
location:"Basar, Arunachal Pradesh",
capacity:"100KW",
capacity_value:100,
scope:["Complete Plant Equipment"],
description:"Supply, Installation testing and commissioning of complete Plant and Equipment of MHP.",
latitude:27.92867,
longitude:94.72430,
image_url:"/images/projects/dhpd.png",
year:2014,
status:"completed",
turbine_type:"unknown"
},

/* ===== 23 ===== */
{
project_id:"p23",
name:"Mayemong MHP",
location:"Nagaland",
capacity:"100KW",
capacity_value:100,
scope:["Turbo Impulse Turbine","E&M Equipment"],
description:"Design, Supply and Installation of Turbo impulse turbine with complete E&M Equipment.",
latitude:25.6701,
longitude:94.1077,
image_url:"/images/projects/ureda.png",
year:2014,
status:"completed",
turbine_type:"impulse"
},

/* ===== 24 ===== */
{
project_id:"p24",
name:"Korakunda Tea Estate",
location:"Nilgiri Hills, Tamil Nadu",
capacity:"60KW",
capacity_value:60,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:11.4064,
longitude:76.6932,
image_url:"/images/projects/ureda.png",
year:2013,
status:"completed",
turbine_type:"unknown"
},

/* ===== 25 ===== */
{
project_id:"p25",
name:"Mechuka MHP",
location:"Shi-Yomi District, Arunachal Pradesh",
capacity:"150KW",
capacity_value:150,
scope:["Control Equipment","Commissioning"],
description:"Supply, Installation, testing and commissioning of complete control equipment of MHP.",
latitude:28.60200,
longitude:94.14082,
image_url:"/images/projects/dhpd.png",
year:2013,
status:"completed",
turbine_type:"unknown"
},
/* ===== 26 ===== */
{
project_id:"p26",
name:"Kanolgad MHP",
location:"Bageshwar, Uttarakhand",
capacity:"100KW",
capacity_value:100,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:29.8370,
longitude:79.7716,
image_url:"/images/projects/ureda.png",
year:2012,
status:"completed",
turbine_type:"unknown"
},

/* ===== 27 ===== */
{
project_id:"p27",
name:"Nee Nallah MHP",
location:"Anini, Arunachal Pradesh",
capacity:"50KW",
capacity_value:50,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:28.7957,
longitude:95.8983,
image_url:"/images/projects/dhpd.png",
year:2012,
status:"completed",
turbine_type:"unknown"
},

/* ===== 28 ===== */
{
project_id:"p28",
name:"Namchik MHP",
location:"Khonsa, Arunachal Pradesh",
capacity:"300KW",
capacity_value:300,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.0167,
longitude:95.5667,
image_url:"/images/projects/dhpd.png",
year:2012,
status:"completed",
turbine_type:"unknown"
},

/* ===== 29 ===== */
{
project_id:"p29",
name:"Sikin Karo MHP",
location:"Ziro, Arunachal Pradesh",
capacity:"200KW",
capacity_value:200,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.5886,
longitude:93.8282,
image_url:"/images/projects/dhpd.png",
year:2012,
status:"completed",
turbine_type:"unknown"
},

/* ===== 30 ===== */
{
project_id:"p30",
name:"Kojin Nallah MHP",
location:"Daporijo, Arunachal Pradesh",
capacity:"100KW",
capacity_value:100,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.9884,
longitude:94.2229,
image_url:"/images/projects/ureda.png",
year:2012,
status:"completed",
turbine_type:"unknown"
},

/* ===== 31 ===== */
{
project_id:"p31",
name:"Tahinallah MHP",
location:"Khonsa, Arunachal Pradesh",
capacity:"2X50KW",
capacity_value:100,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.0167,
longitude:95.5667,
image_url:"/images/projects/ureda.png",
year:2012,
status:"completed",
turbine_type:"unknown"
},

/* ===== 32 ===== */
{
project_id:"p32",
name:"Chunallah MHP",
location:"Anini, Arunachal Pradesh",
capacity:"2X15KW",
capacity_value:30,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:28.7957,
longitude:95.8983,
image_url:"/images/projects/ureda.png",
year:2012,
status:"completed",
turbine_type:"unknown"
},

/* ===== 33 ===== */
{
project_id:"p33",
name:"Lakshmi Estate Project",
location:"Theni, Tamil Nadu",
capacity:"5KW",
capacity_value:5,
scope:["ELC"],
description:"Electronic Load Controller installation.",
latitude:10.0104,
longitude:77.4768,
image_url:"/images/projects/ureda.png",
year:2012,
status:"completed",
turbine_type:"elc"
},

/* ===== 34 ===== */
{
project_id:"p34",
name:"Kedar Ganga MHP",
location:"Gangotri, Uttarakhand",
capacity:"25KW",
capacity_value:25,
scope:["Complete Plant Equipment"],
description:"Supply, Installation testing and commissioning of complete Plant and Equipment of MHP.",
latitude:30.9947,
longitude:78.9398,
image_url:"/images/projects/default.jpg",
year:2012,
status:"completed",
turbine_type:"unknown"
},

/* ===== 35 ===== */
{
project_id:"p35",
name:"TATO MHP",
location:"Aalo, Arunachal Pradesh",
capacity:"2X50KW + 2X20KW",
capacity_value:140,
scope:["Control Equipment"],
description:"Supply, Installation, testing and commissioning of complete control equipment of MHP.",
latitude:28.1736,
longitude:94.7996,
image_url:"/images/projects/default.jpg",
year:2012,
status:"completed",
turbine_type:"unknown"
},



/* ===== 37 ===== */
{
project_id:"p37",
name:"Sinyum Karo MHP",
location:"Ziro, Arunachal Pradesh",
capacity:"2X50KW",
capacity_value:100,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.5886,
longitude:93.8282,
image_url:"/images/projects/default.jpg",
year:2011,
status:"completed",
turbine_type:"unknown"
},

/* ===== 38 ===== */
{
project_id:"p38",
name:"Khadiabeg MHP",
location:"Seppa, Arunachal Pradesh",
capacity:"2X100KW",
capacity_value:200,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.3228,
longitude:92.6840,
image_url:"/images/projects/default.jpg",
year:2011,
status:"completed",
turbine_type:"unknown"
},

/* ===== 39 ===== */
{
project_id:"p39",
name:"Paya MHP",
location:"Ziro, Arunachal Pradesh",
capacity:"2X50KW",
capacity_value:100,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.5886,
longitude:93.8282,
image_url:"/images/projects/default.jpg",
year:2011,
status:"completed",
turbine_type:"unknown"
},

/* ===== 40 ===== */
{
project_id:"p40",
name:"Waterfall Estate Project",
location:"Pollachi, Tamil Nadu",
capacity:"5KW",
capacity_value:5,
scope:["ELC"],
description:"Electronic Load Controller installation.",
latitude:10.6580,
longitude:77.0087,
image_url:"/images/projects/default.jpg",
year:2011,
status:"completed",
turbine_type:"elc"
},
/* ===== 41 ===== */
{
project_id:"p41",
name:"Manimudi Farms Project",
location:"Kodaikanal, Tamil Nadu",
capacity:"5KW",
capacity_value:5,
scope:["ELC"],
description:"Electronic Load Controller installation.",
latitude:10.2381,
longitude:77.4892,
image_url:"/images/projects/default.jpg",
year:2011,
status:"completed",
turbine_type:"elc"
},

/* ===== 42 ===== */
{
project_id:"p42",
name:"Brooke Land Estate Project",
location:"Palakkad, Kerala",
capacity:"5KW",
capacity_value:5,
scope:["ELC"],
description:"Electronic Load Controller installation.",
latitude:10.7867,
longitude:76.6548,
image_url:"/images/projects/default.jpg",
year:2011,
status:"completed",
turbine_type:"elc"
},


/* ===== 44 ===== */
{
project_id:"p44",
name:"Pandukeshwar SHP",
location:"Chamoli, Uttarakhand",
capacity:"3X250KW",
capacity_value:750,
scope:["Electronic Governor","OPU Unit"],
description:"Supply, Installation and commissioning of Electronic Governor and OPU.",
latitude:30.4034,
longitude:79.3200,
image_url:"/images/projects/ujvnl.png",
year:2011,
status:"completed",
turbine_type:"unknown"
},

/* ===== 45 ===== */
{
project_id:"p45",
name:"Pandukeshwar SHP R&M",
location:"Chamoli, Uttarakhand",
capacity:"3X250KW",
capacity_value:750,
scope:["Renovation","Transformer Supply","Panels"],
description:"Complete renovation, repairing of turbine and alternator with electrical upgrades.",
latitude:30.4034,
longitude:79.3200,
image_url:"/images/projects/ujvnl.png",
year:2011,
status:"completed",
turbine_type:"unknown"
},

/* ===== 46 ===== */
{
project_id:"p46",
name:"Rongkong MHP",
location:"Dharchula, Uttarakhand",
capacity:"50KW",
capacity_value:50,
scope:["Complete Plant Equipment"],
description:"Supply, Installation testing and commissioning of complete Plant and Equipment of MHP.",
latitude:29.8475,
longitude:80.5364,
image_url:"/images/projects/default.jpg",
year:2011,
status:"completed",
turbine_type:"unknown"
},

/* ===== 47 ===== */
{
project_id:"p47",
name:"Sela MHP",
location:"Dharchula, Uttarakhand",
capacity:"2X25KW",
capacity_value:50,
scope:["Complete Plant Equipment"],
description:"Supply, Installation testing and commissioning of complete Plant and Equipment of MHP.",
latitude:29.8475,
longitude:80.5364,
image_url:"/images/projects/default.jpg",
year:2011,
status:"completed",
turbine_type:"unknown"
},

/* ===== 48 ===== */
{
project_id:"p48",
name:"Dikshi MHP",
location:"Bomdila, Arunachal Pradesh",
capacity:"30KW",
capacity_value:30,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.2648,
longitude:92.4247,
image_url:"/images/projects/default.jpg",
year:2010,
status:"completed",
turbine_type:"unknown"
},

/* ===== 49 ===== */
{
project_id:"p49",
name:"Sechu Nallah MHP",
location:"Tawang, Arunachal Pradesh",
capacity:"2X50KW",
capacity_value:100,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.60800,
longitude:91.87875,
image_url:"/images/projects/dhpd.png",
year:2010,
status:"completed",
turbine_type:"unknown"
},

/* ===== 50 ===== */
{
project_id:"p50",
name:"Chicklong MHP",
location:"Changlang, Arunachal Pradesh",
capacity:"3X50KW",
capacity_value:150,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.14139,
longitude:95.75783,
image_url:"/images/projects/dhpd.png",
year:2010,
status:"completed",
turbine_type:"unknown"
},

/* ===== 51 ===== */
{
project_id:"p51",
name:"Northern Command J&K Project 1",
location:"Jammu & Kashmir",
capacity:"5KW",
capacity_value:5,
scope:["ELC"],
description:"Electronic Load Controller installation.",
latitude:33.7782,
longitude:76.5762,
image_url:"/images/projects/default.jpg",
year:2010,
status:"completed",
turbine_type:"elc"
},

/* ===== 52 ===== */
{
project_id:"p52",
name:"Northern Command J&K Project 2",
location:"Jammu & Kashmir",
capacity:"5KW",
capacity_value:5,
scope:["ELC"],
description:"Electronic Load Controller installation.",
latitude:33.935139,
longitude:76.65762,
image_url:"/images/projects/default.jpg",
year:2010,
status:"completed",
turbine_type:"elc"
},

/* ===== 53 ===== */
{
project_id:"p53",
name:"Border Road Task Force Project",
location:"Arunachal Pradesh",
capacity:"10KW",
capacity_value:10,
scope:["Governor Repair","OPU Unit"],
description:"Repair of electronic Governor, OPU Unit and control wiring.",
latitude:27.0844,
longitude:93.6053,
image_url:"/images/projects/default.jpg",
year:2010,
status:"completed",
turbine_type:"unknown"
},

/* ===== 54 ===== */
{
project_id:"p54",
name:"Pattanallah SHP",
location:"Seppa, Arunachal Pradesh",
capacity:"2X50KW",
capacity_value:100,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.23600,
longitude:93.01122,
image_url:"/images/projects/dhpd.png",
year:2010,
status:"completed",
turbine_type:"unknown"
},

/* ===== 55 ===== */
{
project_id:"p55",
name:"Pakoti SHP",
location:"Seppa, Arunachal Pradesh",
capacity:"2X50KW",
capacity_value:100,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.39103,
longitude:93.02575,
image_url:"/images/projects/dhpd.png",
year:2010,
status:"completed",
turbine_type:"unknown"
},

/* ===== 56 ===== */
{
project_id:"p56",
name:"Bramdungchung SHP",
location:"Tawang, Arunachal Pradesh",
capacity:"2X50KW",
capacity_value:100,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.5861,
longitude:91.8630,
image_url:"/images/projects/dhpd.png",
year:2010,
status:"completed",
turbine_type:"unknown"
},

/* ===== 57 ===== */
{
project_id:"p57",
name:"Thongling MHP",
location:"Tawang, Arunachal Pradesh",
capacity:"2X100KW",
capacity_value:200,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.57357,
longitude:91.90856,
image_url:"/images/projects/dhpd.png",
year:2010,
status:"completed",
turbine_type:"unknown"
},

/* ===== 58 ===== */
{
project_id:"p58",
name:"Two Bridge Dirang SHP",
location:"Dirang, Arunachal Pradesh",
capacity:"3X100KW",
capacity_value:300,
scope:["Control Panels"],
description:"Supply, installation, testing and commissioning of complete Control Panels.",
latitude:27.35828,
longitude:92.24110,
image_url:"/images/projects/dhpd.png",
year:2010,
status:"completed",
turbine_type:"unknown"
},

/* ===== 59 ===== */
{
project_id:"p59",
name:"Harshil SHP",
location:"Uttarkashi, Uttarakhand",
capacity:"200KW",
capacity_value:200,
scope:["O&M Contract"],
description:"Complete O&M for 3 years.",
latitude:30.7290,
longitude:78.4432,
image_url:"/images/projects/ujvnl.png",
year:2010,
status:"completed",
turbine_type:"unknown"
},

/* ===== 60 ===== */
{
project_id:"p60",
name:"Urgam SHP",
location:"Joshimath, Uttarakhand",
capacity:"2X1500KW",
capacity_value:3000,
scope:["Electronic Governor","Excitation AVR","OPU Repair"],
description:"Supply, Installation and commissioning of Electronic Governor and Excitation AVR.",
latitude:30.56541,
longitude:79.39272,
image_url:"/images/projects/ujvnl.png",
year:2010,
status:"completed",
turbine_type:"unknown"
},

{
project_id:"p61",
name:"Bhikhuriyagad SHP",
location:"Pithoragarh, Uttarakhand",
capacity:"2X250KW",
capacity_value:500,
scope:["Turbine Repair","Electronic Governor","AVR Excitation Panel","OPU Unit","Grid Synchronization"],
description:"Supply,Repair, Maintenance and commissioning of turbine, and AVR Excitation Panel, Governor and OPU Unit.",
latitude:29.627995,
longitude:80.24684,
image_url:"/images/projects/ureda.png",
year:2010,
status:"completed",
turbine_type:"unknown"
},
{
project_id:"p62",
name:"Gauri MHP",
location:"Champawat, Uttarakhand",
capacity:"1X350KW",
capacity_value:350,
scope:["Turbine System","Control Panels","Electronic Governor","AVR Excitation Panel","OPU Unit","Grid Synchronization"],
description:"Complete Turnkey Project Design Supply and Commissioning of project.",
latitude:29.33543,
longitude:80.09093,
image_url:"/images/projects/ureda.png",
year:2021,
status:"completed",
turbine_type:"Turgo-Impulse"
},
{
project_id:"p10",
name:"Yamunotri MHP",
location:"Uttarkashi, Uttarakhand",
capacity:"2*100KW",
capacity_value:200,
scope:["Control Panels","Turbine Repair","Commissioning"],
description:"Repair, Installation and testing of Complete Hydro turbine and Control Panels.",
latitude:30.99434,
longitude:78.46186,
image_url:"/images/projects/ureda.png",
year:2012,
status:"completed",
turbine_type:"crossflow"
},

];

export default projects;